import * as formats from "../../../../common/formats";

require('select2');
require('tempusdominus-bootstrap-4');

var baseDatepickerOpts = {
	locale: 'ja',
	dayViewHeaderFormat: 'YYYY年 M月',
	format: 'YYYY/MM/DD',
};

document.addEventListener('DOMContentLoaded', () => {
	if (document.getElementById('client-invoice-list') != null) {
		$('.date .datepicker').datetimepicker(baseDatepickerOpts);
        setupMonthlyDatepicker();
        setupMonthlyConditionTable();
		clickInvoiceDownloadCheckBoxForAll();
		cancelInvoiceDownloadCheckBoxForAll();

		// 全銀形式ダウンロードボタンクリックイベント
		document.getElementById('download-zengin-format').addEventListener('click', function() {
			$('#client-download-zengin-format_modal').modal('show');
		});

		// モーダル内のダウンロードボタンクリックイベント
		document.getElementById('client-download-zengin-format-exec').addEventListener('click', function() {
			// 選択された請求書IDを取得してフォームを作成し送信
			const actionUrl   = document.getElementById('download-zengin-format').getAttribute('data-action-url');
			const targetDate  = document.getElementById('target_date').value;
			const formatType  = document.getElementById('format_type').value;
			const newlineCode = document.getElementById('newline_code').checked ? '1' : '0';
			const eof         = document.getElementById('eof').checked ? '1' : '0';

			sendDownloadRequest(actionUrl, targetDate, formatType, newlineCode, eof);
		});

		// モーダルが閉じられたときのイベントハンドリング
		$('#client-download-zengin-format_modal').on('hidden.bs.modal', function () {
			document.getElementById('download_error').style.display = 'none';
		});
	}
});

function createHidenInput(name, value) {
	const input = document.createElement('input');
	input.type = 'hidden';
	input.name = name;
	input.value = value;
	return input;
}

// ダウンロードリクエスト送信
function sendDownloadRequest(actionUrl, targetDate, formatType, newlineCode, eof) {
	const selectInvoices = Array.from(document.querySelectorAll('.invoice-download-target:checked')).map((checkbox) => checkbox.value);

	// 請求書IDが選択されていない場合はエラーメッセージを表示して処理を中断
	if (selectInvoices.length === 0) {
		document.getElementById('download_error').style.display = 'block';
		return;
	} else {
		document.getElementById('download_error').style.display = 'none';
	}

	// 振込指定日が選択されていない場合はエラーメッセージを表示して処理を中断
	if (targetDate === '') {
		document.getElementById('target_date_error').style.display = 'block';
		return;
	} else {
		document.getElementById('target_date_error').style.display = 'none';
	}

	const form = document.createElement('form');
	form.method = 'GET';
	form.action = actionUrl;
	document.body.appendChild(form);

	// 選択された請求書IDをフォームに追加
	selectInvoices.forEach((invoiceId) => {
		const input = document.createElement('input');
		input.type = 'hidden';
		input.name = 'invoice_ids[]';
		input.value = invoiceId;
		form.appendChild(input);
	});

	// 対象日付をフォームに追加
	form.appendChild(createHidenInput('target_date', targetDate));

	// フォーマット種別をフォームに追加
	form.appendChild(createHidenInput('format_type', formatType));

	// 改行コードをフォームに追加
	form.appendChild(createHidenInput('newline_code', newlineCode));

	// EOFをフォームに追加
	form.appendChild(createHidenInput('eof', eof));

	// フォームを送信
	form.submit();

	// 送信後、生成したフォームを削除
	document.body.removeChild(form);

	// モーダルを閉じる
	$('#client-download-zengin-format_modal').modal('hide');
}

// 月別条件datepicker構築
function setupMonthlyDatepicker() {
    var monthOpts = {
        ...baseDatepickerOpts,
        viewMode: 'years',
        format: 'YYYY/MM',
    };
    $('.month .datepicker').datetimepicker(monthOpts);

    $('.datepicker').blur(function() {
		var term_start = $('#termStart').val();
        var term_end = $('#termEnd').val();
		var payment_deadline_start = $('#paymentDeadlineStart').val();
        var payment_deadline_end = $('#paymentDeadlineEnd').val();

        $('.datepicker').datetimepicker('hide');

		$('#termStart').val(term_start);
        $('#termEnd').val(term_end);
		$('#paymentDeadlineStart').val(payment_deadline_start);
        $('#paymentDeadlineEnd').val(payment_deadline_end);
    });
}

// 月別条件テーブル構築
function setupMonthlyConditionTable() {
	$(document).on("click", '.js-remove-monthly-condition', function(e) {
		e.preventDefault();
		let tr = $('.js-monthly-table-body .js-data-row');
		if (tr.length > 1) {
			$(this).closest('.js-data-row').remove();
		} else {
			// 最後の1行の時は値のみクリアする
			$(this).closest('.js-data-row').find('input').each(function(i, element) {
				$(element).val('');
			});
		}
	});
	$(document).on("click", '.js-add-monthly-condition', function(e) {
		e.preventDefault();
		let template = $('.js-monthly-table-body .js-data-row').last();
		let row = template.clone();
		let id = row.data('id') + 1;
		row.attr('data-id', id);
		$(row.find('input').get(0)).attr('id', 'month' + id);
		row.find('.js-datepicker-set-target').data('target', '#month' + id);
		$($(row).find('input')).removeClass('is-invalid');
		$('.js-monthly-table-body').append(row);
		setupMonthlyDatepicker();
	});
}

// 全件チェック機能
function clickInvoiceDownloadCheckBoxForAll() {
	$('#invoice-download-all').click(function() {
		if ( $('#invoice-download-all').is(':checked') ) {
			$('.invoice-download-target').prop("checked",true);
		} else {
			$('.invoice-download-target').prop("checked",false);
		}
	});
}

// 全件チェック解除機能
function cancelInvoiceDownloadCheckBoxForAll() {
	$('.invoice-download-target').click(function() {
		if ($(this).not(':checked')) {
			$('#invoice-download-all').prop("checked",false);
		}
	});
}